import { create } from 'zustand';
import { IActiveItem } from '../models/modules';
import { IExercise } from '../../../core/models/exercise';

interface ExerciseState {
  exercise: IExercise | null;
  exercises: IExercise[];
  exercisesList: IExercise[];
  active: IActiveItem | null; //Assunto ativo
  page: number;
  favorite: boolean;
  selectedYear: string[];
  unanswered: boolean;
  rightAnswer: boolean;
  wrongAnswer: boolean;
  isEnem: string[];
  difficulty: string[];
  trialOptions: string;
  questionOptions: string[];
  isLoading: boolean;
  totalExercises: number | null;
  currentModule: { module: string; area: string } | null;
  institutionType: string[];
  setUnanswered: (isUnanswered: boolean) => void;
  setRightAnswer: (isRightAnswer: boolean) => void;
  setWrongAnswer: (isWrongAnswer: boolean) => void;
  setFavorite: (isFavorite: boolean) => void;
  setActive: (subject: IActiveItem | null) => void;
  setExercises: (exercises: IExercise[]) => void;
  setExercisesList: (exercisesList: IExercise[]) => void;
  setIsLoading: (loading: boolean) => void;
  setTotalExercises: (total: number) => void;
  setSelectedYear: (years: string[]) => void;
  setIsEnem: (option: string[]) => void;
  setPage: (page: number) => void;
  setDifficulty: (difficulty: string[]) => void;
  setTrialOptions: (trial: string) => void;
  setQuestionOptions: (question: string[]) => void;
  setExercise: (exercise: IExercise) => void;
  setInstitutionType: (institutionTypes: string[]) => void;
  nextPage: () => void;
  resetExercises: () => void;
  clearFilters: () => void;
}

export const useExerciseStore = create<ExerciseState>((set) => ({
  exercise: null,
  exercises: [] as IExercise[],
  exercisesList: [] as IExercise[],
  active: null,
  isLoading: false,
  totalExercises: null,
  page: 1,
  favorite: JSON.parse(localStorage.getItem('exerciseFavorite') || 'false'),
  unanswered: JSON.parse(localStorage.getItem('exerciseUnanswered') || 'false'),
  rightAnswer: JSON.parse(localStorage.getItem('exerciseRightAnswer') || 'false'),
  wrongAnswer: JSON.parse(localStorage.getItem('exerciseWrongAnswer') || 'false'),
  difficulty: JSON.parse(localStorage.getItem('exerciseDifficulty') || '[]'),
  isEnem: JSON.parse(localStorage.getItem('exerciseIsEnem') || '[]'),
  trialOptions: localStorage.getItem('exerciseTrialOptions') || 'last',
  questionOptions: JSON.parse(localStorage.getItem('exerciseQuestionOptions') || '[]'),
  currentModule: null,
  selectedYear: [],
  institutionType: [],
  setSelectedYear: (years) => set({ selectedYear: years }),
  setInstitutionType: (values) => {
    localStorage.setItem('exerciseInstitutionType', JSON.stringify(values));
    set({ institutionType: values });
  },
  setActive: (subject: IActiveItem | null) => set({ active: subject }),
  setExercises: (exercises: IExercise[]) => set({ exercises: exercises }),
  setExercisesList: (exercisesList: IExercise[]) =>
    set({ exercisesList: exercisesList }),
  setIsLoading: (loading: boolean) => set({ isLoading: loading }),
  setTotalExercises: (total: number) => set({ totalExercises: total }),
  setPage: (page: number) => set({ page: page }),
  setFavorite: (value) => {
    localStorage.setItem('exerciseFavorite', JSON.stringify(value));
    set({ favorite: value });
  },
  setUnanswered: (value) => {
   localStorage.setItem('exerciseUnanswered', JSON.stringify(value));
    set({ unanswered: value });
  },
  setRightAnswer: (value) => {
    localStorage.setItem('exerciseRightAnswer', JSON.stringify(value));
    set({ rightAnswer: value });
  },
  setWrongAnswer: (value) => {
    localStorage.setItem('exerciseWrongAnswer', JSON.stringify(value));
    set({ wrongAnswer: value });
  },
  setDifficulty: (value) => {
    localStorage.setItem('exerciseDifficulty', JSON.stringify(value));
    set({ difficulty: value });
  },
  setIsEnem: (value) => {
    localStorage.setItem('exerciseIsEnem', JSON.stringify(value));
    set({ isEnem: value });
  },
  setTrialOptions: (value) => {
    localStorage.setItem('exerciseTrialOptions', value);
    set({ trialOptions: value });
  },
  setQuestionOptions: (value) => {
    localStorage.setItem('exerciseQuestionOptions', JSON.stringify(value));
    set({ questionOptions: value });
  },
  setExercise: (exercise: IExercise) => set({ exercise: exercise }),
  nextPage: () => set((state) => ({ page: state.page + 1 })),
  resetExercises: () => set({
    exercise: null,
    exercises: [] as IExercise[],
    exercisesList: [] as IExercise[],
    active: null,
    isLoading: false,
    totalExercises: null,
    page: 1,
    difficulty: JSON.parse(localStorage.getItem('exerciseDifficulty') || '[]'),
    isEnem: JSON.parse(localStorage.getItem('exerciseIsEnem') || '[]'),
    trialOptions: localStorage.getItem('exerciseTrialOptions') || 'last',
    questionOptions: JSON.parse(localStorage.getItem('exerciseQuestionOptions') || '[]')
  }),
  clearFilters: () => {
    localStorage.removeItem('exerciseFavorite');
    localStorage.removeItem('exerciseUnanswered');
    localStorage.removeItem('exerciseRightAnswer');
    localStorage.removeItem('exerciseWrongAnswer');
    localStorage.removeItem('exerciseDifficulty');
    localStorage.removeItem('exerciseIsEnem');
    localStorage.removeItem('exerciseTrialOptions');
    localStorage.removeItem('exerciseQuestionOptions');
    localStorage.removeItem('exerciseInstitutionType');
    localStorage.removeItem('selectedSubjects');
    localStorage.removeItem('filterType');
    localStorage.removeItem('filterStatus');

    set({
      favorite: false,
      unanswered: false,
      rightAnswer: false,
      wrongAnswer: false,
      difficulty: [],
      isEnem: [],
      trialOptions: 'last',
      questionOptions: [],
      selectedYear: [],
      institutionType: []
    });
  }
}));
